import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './notifications.component';
import {BadgeModule} from 'primeng/badge';
import {PaginatorModule} from 'primeng/paginator';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import {ToastModule} from 'primeng/toast';


@NgModule({
  declarations: [NotificationsComponent],
    imports: [
        CommonModule,
        BadgeModule,
        PaginatorModule,
        DialogModule,
        ButtonModule,
        RippleModule,
        ToastModule
    ]
})
export class NotificationsModule { }
